import { render, staticRenderFns } from "./AdminRecord.vue?vue&type=template&id=51ad8452&scoped=true&"
import script from "./AdminRecord.vue?vue&type=script&lang=js&"
export * from "./AdminRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad8452",
  null
  
)

export default component.exports